import React from 'react';
import { images, tomos } from '../data/content';
export function TomosSection() {
  return <section aria-labelledby="tomos" className="bg-ink-900" data-id="element-182" data-mp="1kcljrfuyuuuu">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" style={{
      paddingTop: "20px",
      paddingBottom: "25px"
    }} data-id="element-183" data-mp="1kar004vfl8sc">
        <p className="text-center text-sm font-bold uppercase tracking-[0.25em] text-ball-400" data-id="element-184" data-mp="1u2dj0ne0gc5n">
          PADEL PRO-PACK™ 
        </p>
        <h2 id="tomos" className="mx-auto mt-4 max-w-3xl text-center font-display text-3xl uppercase leading-tight text-white sm:text-5xl" style={{
        color: "#4B7BFF"
      }} data-id="element-185" data-mp="xdpfsx6yetga">
          EL SISTEMA COMPLETO EN 6 TOMOS MAESTROS
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-186" data-mp="16f5guebvpj7u">
          Más de 120 páginas de metodología pura. Todo lo que necesitas para enseñar, gestionar y
          escalar tu academia en España.
        </p>

        <div className="mt-10 overflow-hidden rounded-3xl border border-ink-600" data-id="element-187" data-mp="2mq9b1esmxfw3">
          <img src={images.tomos} alt="Caja del Padel Pro-Pack junto a la pila de los 6 manuales sobre una pista de pádel azul" className="h-56 w-full object-cover object-center sm:h-80 lg:h-[420px]" data-id="element-188" data-mp="2qoibhbpe47qg" />
        </div>

        <h3 className="mt-14 text-center font-display text-xl uppercase text-white sm:text-2xl" data-id="element-189" data-mp="2hmhcoaeiddmo">
          LOS 6 TOMOS MAESTROS
        </h3>

        <ol className="mt-6 grid gap-4 md:grid-cols-2" data-id="element-190" data-mp="2cqtq82reuykv">
          {tomos.map(tomo => <li key={tomo.id} className="flex gap-4 rounded-2xl border border-ink-600 bg-ink-800 p-5 transition-colors duration-150 ease-out hover:border-court-500/60" data-id="element-191" data-mp="27qxoyba3ll90">
              <span className="mt-0.5 shrink-0 rounded-lg bg-court-700 px-2.5 py-1 font-display text-xs text-court-50" data-id="element-192" data-mp="1yy447ybvttnr">
                {tomo.id}
              </span>
              <div data-id="element-193" data-mp="1oyvan6kxih1x">
                <p className="font-semibold leading-snug text-white" data-id="element-194" data-mp="1oz4su7zqfjx2">{tomo.title}</p>
                <p className="mt-1.5 text-sm leading-relaxed text-slate-400" data-id="element-195" data-mp="1k0211p8rja71">{tomo.description}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}